import { Link } from "react-router-dom";
import { projects } from "../projects/index";

export function MobileWorkOverview({ onNavigate, isVisible }) {
  return (
    <ul className="mobile-work-menu">
      {projects.map((item) => (
        <li key={item.id} className="mobile-work-row">
          <Link
            to={`/projects/${item.id}`}
            onClick={onNavigate}
            className="mobile-work-link grid-four-cols-sm"
            aria-label={`${item.project} (${item.year}) öffnen`}
            tabIndex={isVisible ? 0 : -1}
          >
            <img
              src={item.thumbnailUrl}
              alt={`${item.project} – Thumbnail`}
              className="start-one-sm span-four-sm square-media-one-by-one"
              loading="lazy"
            />
            <p className="meta-description no-wrap-text start-one-sm span-one-sm">
              {item.year}
            </p>
            <p className="meta-description no-wrap-text start-two-sm span-three-sm">
              {item.project}
            </p>
          </Link>
        </li>
      ))}
    </ul>
  );
}
